<div class="detail">
  <!-- Breadcrumb -->
  <nav aria-label="Đường dẫn" class="border-b border-slate-200 bg-white">
    <ol
      class="m-0 mx-auto flex max-w-7xl list-none flex-wrap items-center gap-x-1.5 gap-y-1 px-4 py-3 text-sm text-slate-500"
    >
      <li>
        <a routerLink="/" class="hover:text-emerald-600">{{
          breadcrumb().root
        }}</a>
      </li>
      <li aria-hidden="true">/</li>
      <li>
        <a [routerLink]="breadcrumb().route" class="hover:text-emerald-600">{{
          breadcrumb().collection
        }}</a>
      </li>
      @if (product(); as bp) {
        @if (breadcrumb().category; as cat) {
          <li aria-hidden="true">/</li>
          <li>
            @if (breadcrumb().categorySlug; as slug) {
              <a
                [routerLink]="breadcrumb().route"
                [queryParams]="{ category: slug }"
                class="hover:text-emerald-600"
                >{{ cat }}</a
              >
            } @else {
              <span>{{ cat }}</span>
            }
          </li>
        }
        <li aria-hidden="true">/</li>
        <li
          class="min-w-0 max-w-full truncate font-medium text-slate-900"
          aria-current="page"
        >
          {{ bp.name }}
        </li>
      }
    </ol>
  </nav>

  <div class="mx-auto max-w-7xl px-4 py-6 md:py-8">
    @if (loading()) {
      <!-- Đang tải: cùng bố cục với trang thật để không bị nhảy -->
      <section
        aria-label="Đang tải sản phẩm"
        aria-busy="true"
        class="grid gap-6 lg:grid-cols-[minmax(0,36rem)_minmax(0,1fr)] lg:gap-8 xl:grid-cols-[minmax(0,40rem)_minmax(0,1fr)]"
      >
        <div class="mx-auto w-full max-w-[42rem] lg:mx-0">
          <span class="sk block aspect-[4/3] w-full"></span>
          <div class="mt-3 flex gap-2 overflow-hidden">
            @for (n of skeletonThumbs; track n) {
              <span class="sk block aspect-[2/3] w-14 shrink-0 sm:w-16"></span>
            }
          </div>
        </div>
        <div class="space-y-4">
          <span class="sk block h-8 w-4/5"></span>
          <span class="sk block h-4 w-1/3"></span>
          <span class="sk block h-14 w-full"></span>
          <span class="sk block h-24 w-full"></span>
          <span class="sk block h-11 w-full"></span>
          <span class="sk block h-20 w-full"></span>
        </div>
      </section>
    } @else if (notFound() || !product()) {
      <!-- Không tìm thấy / rỗng -->
      <section
        class="rounded-xl border border-slate-200 bg-slate-50 px-6 py-14 text-center"
      >
        <mat-icon
          class="!h-10 !w-10 text-slate-400"
          svgIcon="hero:search"
        ></mat-icon>
        <h1 class="mt-3 text-xl font-bold text-slate-900">
          Không tìm thấy sản phẩm
        </h1>
        <p class="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-600">
          Sản phẩm không tồn tại hoặc hiện không còn được hiển thị. Hãy quay lại
          danh sách để chọn sản phẩm khác.
        </p>
        <div class="mt-6 flex flex-wrap justify-center gap-3">
          <button
            type="button"
            (click)="goToListing()"
            class="inline-flex items-center gap-2 rounded-md bg-emerald-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
          >
            <mat-icon svgIcon="hero:arrow_back"></mat-icon>
            Về {{ breadcrumb().collection }}
          </button>
          <a
            routerLink="/"
            class="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 hover:border-emerald-600 hover:text-emerald-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
          >
            <mat-icon svgIcon="hero:home"></mat-icon>
            Trang chủ
          </a>
        </div>
      </section>
    } @else if (product(); as p) {
      <!-- Khối chính: gallery + khung mua hàng -->
      <section
        class="grid gap-6 lg:grid-cols-[minmax(0,36rem)_minmax(0,1fr)] lg:gap-8 xl:grid-cols-[minmax(0,40rem)_minmax(0,1fr)]"
      >
        <!-- Gallery -->
        <div class="mx-auto w-full min-w-0 max-w-[42rem] lg:mx-0">
          <figure
            class="product-image-frame product-detail-image relative m-0 w-full rounded-xl border border-slate-200"
          >
            <button
              type="button"
              #mainImageTrigger
              class="main-image-trigger"
              [attr.aria-label]="'Mở ảnh phóng to của ' + p.name"
              (pointerenter)="updateImageHoverZoom($event)"
              (pointermove)="updateImageHoverZoom($event)"
              (pointerleave)="endImageHoverZoom()"
              (click)="openImageViewer()"
            >
              <img appImgFallback [src]="activeImage()" [alt]="p.name" />
              @if (imageHoverZoom(); as zoom) {
                <span
                  class="image-zoom-lens"
                  aria-hidden="true"
                  [style.width.px]="zoom.lensSize"
                  [style.height.px]="zoom.lensSize"
                  [style.left.px]="zoom.lensLeft"
                  [style.top.px]="zoom.lensTop"
                ></span>
              }
            </button>
          </figure>
          @if (imageHoverZoom(); as zoom) {
            <div
              class="image-zoom-popup"
              aria-hidden="true"
              [style.width.px]="zoom.popupSize"
              [style.height.px]="zoom.popupSize"
              [style.left.px]="zoom.popupLeft"
              [style.top.px]="zoom.popupTop"
            >
              <img
                appImgFallback
                [src]="activeImage()"
                alt=""
                [style.width.px]="zoom.imageWidth"
                [style.height.px]="zoom.imageHeight"
                [style.left.px]="zoom.imageLeft"
                [style.top.px]="zoom.imageTop"
              />
            </div>
          }
          @if (gallery().length > 1) {
            <ul
              class="thumbs m-0 mt-3 flex list-none gap-2 overflow-x-auto p-1 pb-2"
              aria-label="Ảnh sản phẩm"
            >
              @for (img of gallery(); track $index) {
                <li class="shrink-0">
                  <button
                    type="button"
                    (click)="selectImage(img)"
                    [attr.aria-label]="
                      'Xem ảnh ' + ($index + 1) + ' của ' + p.name
                    "
                    [attr.aria-pressed]="img === activeImage()"
                    class="product-image-frame product-detail-thumbnail rounded-lg border-2 bg-white p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
                    [ngClass]="
                      img === activeImage()
                        ? 'border-emerald-600 ring-2 ring-emerald-100'
                        : 'border-slate-200 opacity-80 hover:border-slate-400 hover:opacity-100'
                    "
                  >
                    <img
                      appImgFallback
                      [src]="img"
                      useThumbnail
                      [alt]="'Ảnh ' + ($index + 1) + ' của ' + p.name"
                      loading="lazy"
                    />
                  </button>
                </li>
              }
            </ul>
          }
        </div>

        <!-- Khung mua hàng (sticky trên desktop) -->
        <div class="min-w-0 lg:sticky lg:top-[8.75rem] lg:self-start">
          <div class="rounded-xl border border-slate-200 bg-white p-5 md:p-6">
            @if (p.categoryPath || p.categoryName) {
              <p
                class="m-0 text-xs font-semibold uppercase tracking-wide text-emerald-700"
              >
                {{ p.categoryPath || p.categoryName }}
              </p>
            }
            <h1
              class="m-0 mt-1 break-words text-2xl font-bold leading-tight text-slate-900 md:text-3xl"
            >
              {{ p.name }}
            </h1>
            <p class="mt-2 text-sm text-slate-500">
              Thương hiệu:
              <span class="font-medium text-slate-900">{{ p.brandName }}</span>
              @if (p.model) {
                <span aria-hidden="true"> · </span>Model:
                <span class="font-medium text-slate-900">{{ p.model }}</span>
              }
            </p>

            @if (p.highlights.length) {
              <ul
                class="m-0 mt-4 grid list-none grid-cols-1 gap-2 p-0 text-sm text-slate-700 sm:grid-cols-2"
                aria-label="Thông số nổi bật"
              >
                @for (h of p.highlights; track $index) {
                  <li class="flex items-start gap-2">
                    <mat-icon
                      class="!h-4 !w-4 shrink-0 !text-base text-emerald-600"
                      svgIcon="hero:check"
                    ></mat-icon>
                    <span class="min-w-0 break-words">{{ h }}</span>
                  </li>
                }
              </ul>
            } @else if (p.specs.length) {
              <ul
                class="m-0 mt-4 list-disc space-y-1 pl-5 text-sm text-slate-700"
                aria-label="Thông số chính"
              >
                @for (spec of p.specs.slice(0, 5); track spec.label) {
                  <li>
                    <span class="text-slate-500">{{ spec.label }}:</span>
                    {{ spec.value }}
                  </li>
                }
              </ul>
            }

            @if (p.colors.length) {
              <div class="mt-5">
                <p class="m-0 text-sm font-semibold text-slate-900">
                  @if (
                    p.colors.length === 1 && p.colors[0].name === "Ảnh sản phẩm"
                  ) {
                    Thư viện ảnh
                  } @else {
                    Màu sắc
                  }
                  @if (selectedColor(); as sc) {
                    @if (sc.name !== "Ảnh sản phẩm") {
                      <span class="font-normal text-slate-500"
                        >: {{ sc.name }}</span
                      >
                    }
                  }
                </p>
                <ul
                  class="m-0 mt-2 flex list-none flex-wrap gap-2 p-0"
                  [attr.aria-label]="
                    p.colors.length === 1 && p.colors[0].name === 'Ảnh sản phẩm'
                      ? 'Chọn thư viện ảnh'
                      : 'Chọn màu'
                  "
                >
                  @for (color of p.colors; track $index) {
                    <li>
                      <button
                        type="button"
                        (click)="selectColor(color)"
                        [attr.aria-pressed]="selectedColor() === color"
                        class="color-chip inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
                        [ngClass]="
                          selectedColor() === color
                            ? 'border-emerald-600 bg-emerald-50 text-emerald-700'
                            : 'border-slate-200 bg-white text-slate-700 hover:border-emerald-600'
                        "
                      >
                        @if (colorImage(color); as preview) {
                          <img
                            [src]="preview"
                            useThumbnail
                            alt=""
                            class="h-8 w-8 shrink-0 rounded object-cover"
                          />
                        }
                        {{ color.name }}
                      </button>
                    </li>
                  }
                </ul>
              </div>
            }

            <p class="mt-5 flex items-start gap-2 text-sm text-slate-600">
              <mat-icon
                class="!h-5 !w-5 shrink-0 !text-xl text-emerald-600"
                svgIcon="hero:verified_user"
              ></mat-icon>
              <span>
                @if (p.warrantyMonths) {
                  Bảo hành chính hãng {{ p.warrantyMonths }} tháng.
                } @else {
                  Hỗ trợ bảo hành theo chính sách của nhà cung cấp.
                }
              </span>
            </p>

            <!-- Liên hệ mua hàng -->
            <div class="mt-5 grid gap-3 sm:grid-cols-2">
              <a
                [href]="'tel:' + hotline()"
                class="inline-flex items-center justify-center gap-2 rounded-md bg-emerald-700 px-5 py-3 text-sm font-semibold text-white hover:bg-emerald-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
              >
                <mat-icon svgIcon="hero:phone_in_talk"></mat-icon>
                Gọi {{ site().contact.phoneLabel }}
                {{ site().contact.phoneDisplay }}
              </a>
              <a
                [href]="zaloUrl()"
                target="_blank"
                rel="noopener noreferrer"
                class="inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-800 hover:border-emerald-600 hover:text-emerald-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
              >
                <mat-icon svgIcon="hero:forum"></mat-icon>
                Chat Zalo tư vấn
              </a>
            </div>
            <p class="mb-0 mt-3 text-xs text-slate-500">
              Đơn vị cung cấp:
              <span class="font-medium text-slate-700">{{
                p.companyName
              }}</span>
            </p>
          </div>

          <!-- Cam kết (cùng nội dung với trang chủ) -->
          <ul
            class="m-0 mt-4 grid list-none grid-cols-1 gap-3 p-0 sm:grid-cols-2"
            aria-label="Cam kết của cửa hàng"
          >
            @for (t of trustItems(); track t.title) {
              <li
                class="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-3"
              >
                <mat-icon
                  class="!h-6 !w-6 shrink-0 !text-2xl text-emerald-600"
                  [svgIcon]="'hero:' + t.icon"
                ></mat-icon>
                <div class="min-w-0">
                  <p class="m-0 text-sm font-semibold text-slate-900">
                    {{ t.title }}
                  </p>
                  <p class="m-0 mt-0.5 text-xs leading-5 text-slate-500">
                    {{ t.text }}
                  </p>
                </div>
              </li>
            }
          </ul>
        </div>
      </section>

      @if (imageViewerOpen()) {
        <div
          class="image-lightbox"
          role="dialog"
          aria-modal="true"
          [attr.aria-label]="'Ảnh phóng to của ' + p.name"
          (click)="closeImageViewer()"
          (document:keydown)="handleImageViewerKeydown($event)"
        >
          <div
            class="image-lightbox__content"
            (click)="$event.stopPropagation()"
          >
            <button
              type="button"
              #imageViewerCloseButton
              class="image-lightbox__close"
              aria-label="Đóng ảnh phóng to"
              (click)="closeImageViewer()"
            >
              <span aria-hidden="true">×</span>
              Đóng
            </button>
            <img
              appImgFallback
              class="image-lightbox__image"
              [src]="activeImage()"
              [alt]="p.name"
            />
          </div>
        </div>
      }

      <!-- Cấu Tạo Sản Phẩm -->
      <div
        class="mt-8 grid gap-5 md:mt-10 md:grid-cols-[minmax(0,2fr)_minmax(16rem,1fr)]"
      >
        <section
          id="product-description"
          class="flex flex-col"
          aria-labelledby="pd-desc-title"
        >
          <h2
            id="pd-desc-title"
            class="m-0 inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
          >
            Cấu Tạo Sản Phẩm
          </h2>
          <div
            class="mt-4 flex-1 rounded-xl border border-slate-200 bg-white p-4 md:p-6"
          >
            @if (p.description) {
              <p
                class="m-0 whitespace-pre-line break-words text-sm leading-7 text-slate-700"
              >
                {{ p.description }}
              </p>
            } @else {
              <p class="m-0 text-sm text-slate-500">
                Sản phẩm chưa có mô tả. Liên hệ hotline để được tư vấn chi tiết.
              </p>
            }
          </div>
        </section>

        <section
          id="product-warranty"
          class="flex flex-col"
          aria-labelledby="pd-warranty-title"
        >
          <h2
            id="pd-warranty-title"
            class="m-0 inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
          >
            Bảo hành
          </h2>
          <div
            class="mt-4 flex-1 rounded-xl border border-emerald-100 bg-emerald-50/60 p-4 md:p-6"
          >
            @if (p.warrantyDetails) {
              <p
                class="m-0 whitespace-pre-line break-words text-sm leading-7 text-slate-700"
              >
                {{ p.warrantyDetails }}
              </p>
            } @else if (p.warrantyMonths) {
              <p class="m-0 text-sm leading-7 text-slate-700">
                Bảo hành chính hãng {{ p.warrantyMonths }} tháng.
              </p>
            } @else {
              <p class="m-0 text-sm leading-7 text-slate-600">
                Hỗ trợ bảo hành theo chính sách của nhà cung cấp.
              </p>
            }
          </div>
        </section>
      </div>

      <!-- Thông số kỹ thuật -->
      <section
        id="product-specs"
        class="mt-8 md:mt-10"
        aria-labelledby="pd-specs-title"
      >
        <h2
          id="pd-specs-title"
          class="m-0 inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
        >
          Thông số kỹ thuật
        </h2>
        <div
          class="mt-4 overflow-hidden rounded-xl border border-slate-200 bg-white"
        >
          <dl id="pd-specs-list" class="m-0 divide-y divide-slate-200">
            @for (spec of visibleSpecs(); track spec.label) {
              <div
                class="grid gap-1 px-4 py-2.5 text-sm sm:grid-cols-[14rem_1fr] sm:gap-6 md:px-6"
                [class.bg-slate-50]="$odd"
              >
                <dt class="text-slate-500">{{ spec.label }}</dt>
                <dd class="m-0 break-words font-medium text-slate-900">
                  {{ spec.value }}
                </dd>
              </div>
            }
          </dl>
          @if (p.specs.length > specsPreviewCount) {
            <div class="border-t border-slate-200 bg-white p-3 text-center">
              <button
                type="button"
                (click)="toggleSpecs()"
                [attr.aria-expanded]="specsExpanded()"
                aria-controls="pd-specs-list"
                class="inline-flex items-center gap-1 rounded-md px-3 py-1.5 text-sm font-semibold text-emerald-700 hover:bg-emerald-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
              >
                {{
                  specsExpanded()
                    ? "Thu gọn"
                    : "Xem thêm " +
                      (p.specs.length - specsPreviewCount) +
                      " thông số"
                }}
                <mat-icon
                  class="!h-5 !w-5 !text-xl"
                  [svgIcon]="
                    specsExpanded() ? 'hero:close' : 'hero:expand_more'
                  "
                ></mat-icon>
              </button>
            </div>
          }
        </div>
      </section>

      <!-- Sản phẩm liên quan -->
      @if (relatedProducts().length) {
        <section class="mt-10 md:mt-12" aria-labelledby="pd-related">
          <div class="flex flex-wrap items-end justify-between gap-3">
            <h2
              id="pd-related"
              class="m-0 inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
            >
              Sản phẩm liên quan
            </h2>
            <a
              [routerLink]="breadcrumb().route"
              class="inline-flex items-center gap-1 text-sm font-semibold text-emerald-700 hover:text-emerald-800"
            >
              Xem tất cả
              <mat-icon
                class="!h-5 !w-5 !text-xl"
                svgIcon="hero:arrow_forward"
              ></mat-icon>
            </a>
          </div>
          <div
            class="mt-5 grid grid-cols-1 gap-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5"
          >
            @for (r of relatedCards(); track r.id) {
              <app-product-card [product]="r"></app-product-card>
            }
          </div>
        </section>
      }

      <!-- Thanh liên hệ cố định (mobile) -->
      <div
        class="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 px-4 py-3 shadow-[0_-4px_12px_rgba(15,23,42,0.08)] backdrop-blur lg:hidden"
        role="region"
        aria-label="Liên hệ mua hàng"
      >
        <div class="mx-auto flex max-w-7xl items-center gap-3">
          <div class="min-w-0 flex-1">
            <p class="m-0 truncate text-xs text-slate-500">{{ p.name }}</p>
          </div>
          <a
            [href]="zaloUrl()"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat Zalo tư vấn"
            class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-slate-300 bg-white text-slate-800 hover:border-emerald-600 hover:text-emerald-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
          >
            <mat-icon svgIcon="hero:forum"></mat-icon>
          </a>
          <a
            [href]="'tel:' + hotline()"
            [attr.aria-label]="'Gọi ' + site().contact.phoneDisplay"
            class="inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-md bg-emerald-700 px-4 text-sm font-semibold text-white hover:bg-emerald-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
          >
            <mat-icon svgIcon="hero:phone_in_talk"></mat-icon>
            Gọi ngay
          </a>
        </div>
      </div>
    }
  </div>
</div>
